import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackQuickFiltersEvents = createAnalyticsTracker('quickFilter');
